import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Agent = {
  airdropAllocation?: Maybe<Scalars['String']['output']>;
  dailyChatLimit: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  greeting?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  ownerUserId?: Maybe<Scalars['String']['output']>;
  socialLinks?: Maybe<Array<SocialLink>>;
  tagline?: Maybe<Scalars['String']['output']>;
  trendingIndex: Scalars['Float']['output'];
  uid: Scalars['String']['output'];
};

export type AgentInput = {
  airdropAllocation?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  greeting?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  socialLinks: Array<SocialLinkInput>;
  tagline?: InputMaybe<Scalars['String']['input']>;
  uid: Scalars['String']['input'];
};

export type Chat = {
  agentUid: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  role: ChatRole;
  updatedAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export enum ChatRole {
  Assistant = 'assistant',
  User = 'user'
}

export type Config = {
  env: Scalars['String']['output'];
};

export type Knowledge = {
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type KnowledgeInput = {
  text?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  createAgent: Agent;
  deleteKnowledge: Scalars['String']['output'];
  sendMessage: Chat;
  submitKnowledge: Scalars['String']['output'];
  updateAgent: Agent;
};


export type MutationCreateAgentArgs = {
  agent: AgentInput;
  knowledge: KnowledgeInput;
};


export type MutationDeleteKnowledgeArgs = {
  agentUid: Scalars['String']['input'];
  knowledgeId: Scalars['String']['input'];
};


export type MutationSendMessageArgs = {
  agentUid: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type MutationSubmitKnowledgeArgs = {
  agentUid: Scalars['String']['input'];
  knowledge: KnowledgeInput;
};


export type MutationUpdateAgentArgs = {
  agent: AgentInput;
};

export type Query = {
  agent?: Maybe<Agent>;
  agents: Array<Agent>;
  chats: Array<Chat>;
  coBuildPoints: Scalars['Int']['output'];
  coBuildPointsByUser: Scalars['Int']['output'];
  coBuildUserCount: Scalars['Int']['output'];
  config: Config;
  countAgentChatsToday: Scalars['Int']['output'];
  countUserChatsToday: Scalars['Int']['output'];
  countUserSubmittedKnowledgesToday: Scalars['Int']['output'];
  dailyUserChatsLimit: Scalars['Int']['output'];
  dailyUserSubmittedKnowledgesLimit: Scalars['Int']['output'];
  knowledgeById?: Maybe<Knowledge>;
  knowledges: Array<Knowledge>;
  trendingIndex: Scalars['Float']['output'];
};


export type QueryAgentArgs = {
  uid: Scalars['String']['input'];
};


export type QueryAgentsArgs = {
  contributorUserId: Scalars['String']['input'];
};


export type QueryChatsArgs = {
  agentUid: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCoBuildPointsArgs = {
  agentUid: Scalars['String']['input'];
};


export type QueryCoBuildPointsByUserArgs = {
  agentUid: Scalars['String']['input'];
};


export type QueryCoBuildUserCountArgs = {
  agentUid: Scalars['String']['input'];
};


export type QueryCountAgentChatsTodayArgs = {
  agentUid: Scalars['String']['input'];
};


export type QueryCountUserChatsTodayArgs = {
  agentUid: Scalars['String']['input'];
};


export type QueryCountUserSubmittedKnowledgesTodayArgs = {
  agentUid: Scalars['String']['input'];
};


export type QueryDailyUserChatsLimitArgs = {
  agentUid: Scalars['String']['input'];
};


export type QueryDailyUserSubmittedKnowledgesLimitArgs = {
  agentUid: Scalars['String']['input'];
};


export type QueryKnowledgeByIdArgs = {
  agentUid: Scalars['String']['input'];
  knowledgeId: Scalars['String']['input'];
};


export type QueryKnowledgesArgs = {
  agentUid: Scalars['String']['input'];
};


export type QueryTrendingIndexArgs = {
  agentUid: Scalars['String']['input'];
};

export type SocialLink = {
  platform: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SocialLinkInput = {
  platform: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type AgentQueryVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type AgentQuery = { agent?: { id: number, uid: string, name: string, tagline?: string, description: string, greeting?: string, airdropAllocation?: string, ownerUserId?: string, dailyChatLimit: number, trendingIndex: number, socialLinks?: Array<{ platform: string, url: string }> } };

export type AgentExtraInfoQueryVariables = Exact<{
  agentUid: Scalars['String']['input'];
}>;


export type AgentExtraInfoQuery = { trendingIndex: number, coBuildPoints: number, coBuildPointsByUser: number, coBuildUserCount: number, countUserChatsToday: number, countUserSubmittedKnowledgesToday: number };

export type ChatLimitInfoQueryVariables = Exact<{
  agentUid: Scalars['String']['input'];
}>;


export type ChatLimitInfoQuery = { dailyUserChatsLimit: number, countUserChatsToday: number };

export type ChatsQueryVariables = Exact<{
  agentUid: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ChatsQuery = { chats: Array<{ id: number, agentUid: string, content: string, createdAt: string, role: ChatRole, updatedAt: string, userId: string }> };

export type DeleteKnowledgeMutationVariables = Exact<{
  agentUid: Scalars['String']['input'];
  knowledgeId: Scalars['String']['input'];
}>;


export type DeleteKnowledgeMutation = { deleteKnowledge: string };

export type KnowledgesQueryVariables = Exact<{
  agentUid: Scalars['String']['input'];
}>;


export type KnowledgesQuery = { knowledges: Array<{ id: string, text: string, provider: string, createdAt: string }> };

export type SendMessageMutationVariables = Exact<{
  agentUid: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type SendMessageMutation = { sendMessage: { id: number, agentUid: string, content: string, createdAt: string, role: ChatRole, updatedAt: string, userId: string } };

export type SubmitKnowledgeMutationVariables = Exact<{
  agentUid: Scalars['String']['input'];
  knowledge: KnowledgeInput;
}>;


export type SubmitKnowledgeMutation = { submitKnowledge: string };


export const AgentDocument = gql`
    query agent($uid: String!) {
  agent(uid: $uid) {
    id
    uid
    name
    tagline
    description
    greeting
    airdropAllocation
    ownerUserId
    socialLinks {
      platform
      url
    }
    dailyChatLimit
    trendingIndex
  }
}
    `;
export const AgentExtraInfoDocument = gql`
    query agentExtraInfo($agentUid: String!) {
  trendingIndex(agentUid: $agentUid)
  coBuildPoints(agentUid: $agentUid)
  coBuildPointsByUser(agentUid: $agentUid)
  coBuildUserCount(agentUid: $agentUid)
  countUserChatsToday(agentUid: $agentUid)
  countUserSubmittedKnowledgesToday(agentUid: $agentUid)
}
    `;
export const ChatLimitInfoDocument = gql`
    query chatLimitInfo($agentUid: String!) {
  dailyUserChatsLimit(agentUid: $agentUid)
  countUserChatsToday(agentUid: $agentUid)
}
    `;
export const ChatsDocument = gql`
    query chats($agentUid: String!, $limit: Int = 10) {
  chats(agentUid: $agentUid, limit: $limit) {
    id
    agentUid
    content
    createdAt
    role
    updatedAt
    userId
  }
}
    `;
export const DeleteKnowledgeDocument = gql`
    mutation deleteKnowledge($agentUid: String!, $knowledgeId: String!) {
  deleteKnowledge(agentUid: $agentUid, knowledgeId: $knowledgeId)
}
    `;
export const KnowledgesDocument = gql`
    query knowledges($agentUid: String!) {
  knowledges(agentUid: $agentUid) {
    id
    text
    provider
    createdAt
  }
}
    `;
export const SendMessageDocument = gql`
    mutation sendMessage($agentUid: String!, $message: String!) {
  sendMessage(agentUid: $agentUid, message: $message) {
    id
    agentUid
    content
    createdAt
    role
    updatedAt
    userId
  }
}
    `;
export const SubmitKnowledgeDocument = gql`
    mutation submitKnowledge($agentUid: String!, $knowledge: KnowledgeInput!) {
  submitKnowledge(agentUid: $agentUid, knowledge: $knowledge)
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    agent(variables: AgentQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AgentQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AgentQuery>({ document: AgentDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'agent', 'query', variables);
    },
    agentExtraInfo(variables: AgentExtraInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<AgentExtraInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AgentExtraInfoQuery>({ document: AgentExtraInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'agentExtraInfo', 'query', variables);
    },
    chatLimitInfo(variables: ChatLimitInfoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ChatLimitInfoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChatLimitInfoQuery>({ document: ChatLimitInfoDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'chatLimitInfo', 'query', variables);
    },
    chats(variables: ChatsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<ChatsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ChatsQuery>({ document: ChatsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'chats', 'query', variables);
    },
    deleteKnowledge(variables: DeleteKnowledgeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<DeleteKnowledgeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteKnowledgeMutation>({ document: DeleteKnowledgeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'deleteKnowledge', 'mutation', variables);
    },
    knowledges(variables: KnowledgesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<KnowledgesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<KnowledgesQuery>({ document: KnowledgesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'knowledges', 'query', variables);
    },
    sendMessage(variables: SendMessageMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SendMessageMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendMessageMutation>({ document: SendMessageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'sendMessage', 'mutation', variables);
    },
    submitKnowledge(variables: SubmitKnowledgeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<SubmitKnowledgeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubmitKnowledgeMutation>({ document: SubmitKnowledgeDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'submitKnowledge', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;